import React, { useContext } from 'react';

import {
  Box,
  Container,
  makeStyles,
  Typography,
  Grid
} from '@material-ui/core';

// Páginas
import Page from 'src/components/Page';

import Input from '../../shared/component/FormElements/Input';
import Button from '../../shared/component/FormElements/Button';
import ErrorMessage from '../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../shared/component/UIElements/LoadingSpinner';
import { VALIDATOR_EMAIL, VALIDATOR_REQUIRE } from '../../utils/validators';
import { useForm } from '../../hooks/form-hook';
import { useHttpClient } from '../../hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import './Auth.css';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  titulo: {
    textTransform: 'uppercase',
    color: '#3A3A3A',
    fontWeight: 700,
    fontSize: '24px',
    marginBottom: '15px',
  },
  chamada: {
    color: '#707070',
    fontWeight: 400,
    fontSize: '17px',
    textAlign: 'left',
    display: 'block',
    width: '100%',
    marginTop: '15px'
  }
}));
const Auth = () => {
  const auth = useContext(AuthContext);
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const classes = useStyles();
  const [formState, inputHandler] = useForm({
    email: {
      value: '',
      isValid: false
    },
    senha: {
      value: '',
      isValid: false
    }
  }, false);

  const authSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/entrar`,
        'POST',
        JSON.stringify({
          email: formState.inputs.email.value,
          senha: formState.inputs.senha.value,
        }),
        { 'Content-Type': 'application/json' }
      );
      console.log(response);
      auth.login(response.data.id, response.accessToken, response.data.permissao, response.data.nome, response.data.avatar);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Page
      className={classes.root}
      title="Acesso"
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="lg">
          <Grid
            container
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={6} spacing={5}>
              <Box mb={3}>
                <img
                  alt="Logo"
                  src="/static/login.png"
                  style={{
                    maxWidth: '470px',
                    margin: '0 auto',
                    display: 'block'
                  }}
                />
                <img
                  alt="Logo"
                  src="/static/memorial.png"
                  style={{
                    maxWidth: '270px',
                    margin: '100px auto auto auto',
                    display: 'block'
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={6} spacing={5}>
              <Typography
                color="textPrimary"
                align="left"
                variant="h1"
                className={classes.titulo}
              >
                Acesso
              </Typography>
              <Typography
                color="textPrimary"
                align="left"
                variant="span"
                className={classes.chamada}
              >
                Entre com seu login e senha.
              </Typography>
              <form onSubmit={authSubmitHandler}>
                {isLoading && <LoadingSpinner asOverlay />}
                <Box my={2}>
                  <Input
                    id="email"
                    element="input"
                    type="email"
                    label="Endereço de E-mail"
                    fullWidth
                    validators={[VALIDATOR_EMAIL()]}
                    errorText="Insira um e-mail válido."
                    onInput={inputHandler}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <Input
                    id="senha"
                    element="input"
                    type="password"
                    label="Senha"
                    fullWidth
                    validators={[VALIDATOR_REQUIRE()]}
                    errorText="Insira sua senha."
                    variant="outlined"
                    onInput={inputHandler}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <Button
                    color="secondary"
                    disabled={!formState.isValid}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Acessar
                  </Button>
                </Box>
                <ErrorMessage error={error} onClear={clearError} />
              </form>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Page>
  );
};

export default Auth;
